module.exports = __webpack_public_path__ + "static/img/shl_introduce_tab_profile_selected.e107cfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_introduce_tab_profile_selected.png
// module id = UJMf
// module chunks = 5